import React from "react";
import { Button, FormControlLabel, Paper, Checkbox } from "material-ui";
import CTable, {
  CTableHead,
  CTableBody,
  CTableRow,
  CHeadCell,
  CBodyCell
} from "uis/CTable";
import CTextField from "uis/CTextField";
import { withStyles } from "material-ui/styles";

import AdminModalContainer from "containers/AdminList/AdminModalContainer";

const styles = () => ({
  container: {
    padding: 20,
    margin: "20px auto",
    width: 1100
  },
  header: {
    display: "flex"
  },
  title: {
    margin: 0,
    flex: 1
  },
  main: {
    padding: 20
  },
  searchArea: {
    display: "flex",
    float: "left",
    marginBottom: 5
  },
  searchForm: {
    float: "left",
    marginRight: 20
  },
  searchCheckbox: {
    marginTop: 10
  },
  searchBtn: {
    float: "right"
  },
  clear: {
    clear: "both"
  },
  center: {
    textAlign: "center"
  },
  tableCellLink: {
    width: 100
  }
});

class AdminList extends React.Component {
  componentWillMount() {
    this.props.fetchAdminList(this.props.adminList.search);
  }

  render() {
    const { classes, adminList } = this.props;
    const { search } = adminList;

    return (
      <Paper className={classes.container}>
        <AdminModalContainer
          fetchAdminList={() => this.props.fetchAdminList(search)}
        />

        <div className={classes.header}>
          <h2 className={classes.title}>管理者一覧</h2>

          <Button raised onClick={this.props.openAdminModal(null)}>
            新規登録
          </Button>
          <div className={classes.clear} />
        </div>

        <div className={classes.main}>
          <div className={classes.searchArea}>
            <CTextField
              label="管理者ID"
              value={search.adminKey}
              className={classes.searchForm}
              onChange={e =>
                this.props.changeSearchForm("adminKey", e.target.value)
              }
            />

            <CTextField
              label="管理者名"
              value={search.adminName}
              className={classes.searchForm}
              onChange={e =>
                this.props.changeSearchForm("adminName", e.target.value)
              }
            />

            <form className={classes.searchForm} noValidate autoComplete="off">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={search.showInvalidAdmin}
                    onChange={e =>
                      this.props.changeSearchForm(
                        "showInvalidAdmin",
                        e.target.checked
                      )
                    }
                  />
                }
                className={classes.searchCheckbox}
                label="無効の管理者も表示"
              />
            </form>
          </div>
          <Button
            raised
            className={classes.searchBtn}
            onClick={() => this.props.fetchAdminList(search)}
          >
            検索
          </Button>
          <div className={classes.clear} />

          <CTable>
            <CTableHead>
              <CTableRow>
                <CHeadCell>管理者ID</CHeadCell>
                <CHeadCell>管理者名</CHeadCell>
                <CHeadCell>メールアドレス</CHeadCell>
                <CHeadCell>無効</CHeadCell>
                <CHeadCell className={classes.tableCellLink}>{}</CHeadCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {adminList.admins.map(admin => (
                <CTableRow key={admin.id}>
                  <CBodyCell>{admin.adminKey}</CBodyCell>
                  <CBodyCell>{admin.adminName}</CBodyCell>
                  <CBodyCell>{admin.mail || "-"}</CBodyCell>
                  <CBodyCell center>{admin.isInvalid() ? "◯" : "−"}</CBodyCell>
                  <CBodyCell center>
                    <Button onClick={this.props.openAdminModal(admin.id)}>
                      編集
                    </Button>
                  </CBodyCell>
                </CTableRow>
              ))}
            </CTableBody>
          </CTable>
        </div>
      </Paper>
    );
  }
}

export default withStyles(styles)(AdminList);



// WEBPACK FOOTER //
// ./src/components/AdminList/index.jsx